import React, { useEffect, useState } from 'react';
import axios from 'axios';
import config from '../config';

const sameId = (a, b) => String(a || '') === String(b || '');

const OngoingGroupCallCard = ({ call, joining = false, onJoin }) => {
  const [group, setGroup] = useState(null);
  const isVideo = call?.callType === 'video';

  useEffect(() => {
    if (!call?.groupId) return undefined;
    let cancelled = false;
    axios
      .get(`${config.apiUrl}/api/groups/${call.groupId}`)
      .then((res) => {
        if (!cancelled) setGroup(res.data || null);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [call?.groupId]);

  const name = group?.name || call?.groupName || 'Group';
  const members = Array.isArray(group?.members) ? group.members : [];
  const faces = (call?.participantIds || [])
    .map((id) => {
      const member = members.find((entry) => {
        const user = entry?.user || entry;
        return sameId(user?._id || user?.id, id);
      });
      const user = member?.user || member;
      if (!user) return null;
      return {
        id: String(user._id || user.id || id),
        name: user.username || '',
        image: user.profileImage || '',
      };
    })
    .filter(Boolean)
    .slice(0, 3);

  return (
    <div className="ongoing-group-call-card">
      <div className="ongoing-group-call-avatar" aria-hidden="true">
        {group?.avatar ? (
          <img src={`${config.apiUrl}${group.avatar}`} alt="" />
        ) : (
          <span className="notranslate">{name.charAt(0).toUpperCase()}</span>
        )}
      </div>
      <div className="ongoing-group-call-copy">
        <div className="ongoing-group-call-name notranslate">{name}</div>
        <div className="ongoing-group-call-status">
          Ongoing {isVideo ? 'video' : 'audio'} call
        </div>
        {faces.length > 0 && (
          <div className="ongoing-group-call-faces" aria-hidden="true">
            {faces.map((face) => (
              face.image ? (
                <img key={face.id} src={`${config.apiUrl}${face.image}`} alt="" />
              ) : (
                <span key={face.id}>{face.name.charAt(0).toUpperCase() || '?'}</span>
              )
            ))}
          </div>
        )}
      </div>
      <button
        type="button"
        className="ongoing-group-call-join"
        onClick={onJoin}
        disabled={joining}
      >
        {isVideo ? (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <polygon points="23 7 16 12 23 17 23 7" />
            <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
          </svg>
        ) : (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
          </svg>
        )}
        {joining ? 'Joining…' : 'Join'}
      </button>
    </div>
  );
};

export default OngoingGroupCallCard;
